import debug from "debug";

import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/scroll-to-first-error';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-scroll-to-first-error]';
const CLASSNAME_ATTR = 'data-scroll-to-first-error-selector';
const PARENT_CLASSNAME_ATTR = 'data-scroll-to-first-error-parent-selector';
const ERROR_CLASSNAME = '.field-validation-error';
const ERROR_PARENT_CLASSNAME = '.form-field';


class ScrollToFirstError {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.className = this.$element.attr(CLASSNAME_ATTR);
		if (typeof(this.className) == 'undefined') {
			this.className = ERROR_CLASSNAME;
		}
		this.parentClassName = this.$element.attr(PARENT_CLASSNAME_ATTR);
		if (typeof(this.parentClassName) == 'undefined') {
			this.parentClassName = ERROR_PARENT_CLASSNAME;
		}

		this.$firstErrorElement = this.$element.find(this.className).length > 0 ? this.$element.find(this.className) : '';
		this.$firstErrorParentElement = this.$firstErrorElement.length > 0 ? this.$firstErrorElement.closest(this.parentClassName) : '';
		log('ScrollToFirstError', element, options);
		this.watch();
	}

	watch() {
		if (this.$element.is(':visible') && this.$firstErrorElement != ''&& this.$firstErrorParentElement != '' && typeof(this.$firstErrorElement) !== 'undefined' && typeof(this.$firstErrorParentElement) !== 'undefined') {
			var viewportElementOffsetTop = this.$firstErrorParentElement.offset().top;
			$('html, body').animate({
                scrollTop: viewportElementOffsetTop
            }, 20);
		}
		log('bound', this.element);
	}
}

ScrollToFirstError.DEFAULTS = {};

plugin('scrollToFirstError', ScrollToFirstError);

export function exec() {
	$(document).ready(() => {
		log('binding');
		setTimeout(function() {
			$(ELEMENT_SELECTOR).scrollToFirstError();
		},200);

		log('bound');
	});
}





// WEBPACK FOOTER //
// ./client/src/core/modules/scroll-to-first-error/index.js